import { render } from "./LogoComponent.vue?vue&type=template&id=60313240&scoped=true"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import "./LogoComponent.vue?vue&type=style&index=0&id=60313240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60313240"]])

export default __exports__